<!-- 由 suu 创建于 2022-05-06 星期五 -->
<template>
  <div class="ques-result">
    <!-- 顶部背景 -->
    <img
      class="top-bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/lisa-top-bg"
      alt=""
    />
    <!-- 顶部 -->
    <div class="qr-top">
      <!-- 冒号 -->
      <img
        class="t-img"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/lisa-hh"
        alt=""
      />
      <!-- 头像 -->
      <img class="t-head" :src="info.image" alt="" />
      <!-- 姓名 -->
      <div class="t-name">{{ info.name }} <span>的体型是</span></div>
      <!-- 内容 -->
      <div
        class="t-desc"
        :class="{
          't-desc-one':
            icons.length == 1 || (icons.length == 4 && !titles.length)
        }"
      >
        <div class="d-left">
          <div class="l-list" v-if="titles.length > 1">
            {{ titles.join(' & ') }}主导的
          </div>
          <div class="l-title">{{ info.msg }}</div>
        </div>
        <!-- 长度为3时 根据UI 数据和样式都旋转处理 -->
        <div class="d-right" :class="{ 'd-right-three': icons.length == 3 }">
          <img class="r-img" :src="icons[0]" v-if="icons.length == 1" alt="" />
          <img
            class="r-img r-img-more"
            v-for="(item, index) in icons"
            :key="index"
            :src="item"
            v-else
            alt=""
          />
        </div>
      </div>
      <!-- 话术 -->
      <img class="t-say" :src="info.describe" alt="" />
    </div>
    <!-- 底部 -->
    <img class="qr-bot" :src="info.type_img" alt="" />
    <!-- 底部跳转按钮 -->
    <div class="qr-btn user-btn" @click="handelBtnClick"></div>
  </div>
</template>

<script>
export default {
  name: 'ques-result',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {}
  },

  computed: {
    titles() {
      let arr = []
      for (const key in this.info.list) {
        if (Object.hasOwnProperty.call(this.info.list, key)) {
          const ele = this.info.list[key]
          ele.title && arr.push(ele.title)
        }
      }
      return arr
    },
    icons() {
      let arr = []
      for (const key in this.info.list) {
        if (Object.hasOwnProperty.call(this.info.list, key)) {
          const ele = this.info.list[key]
          ele.img_url && arr.push(ele.img_url)
        }
      }
      // <!-- 长度为3时 根据UI 数据和样式都旋转处理 -->
      return arr.length === 3 ? arr.reverse() : arr
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 点击课程按钮
     */
    handelBtnClick() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/miniProgram?userName=gh_3da9370ac840&path=page/home/index'
        )
      } else {
        this.$toast('请前往APP打开')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ques-result {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  background: #f7f7f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  .top-bg {
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .qr-top {
    width: 335px;
    background: #ffffff;
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top: 67px;
    padding-bottom: 20px;
    .t-img {
      width: 48px;
      position: absolute;
      top: 86px;
      left: 22px;
      display: block;
    }
    .t-head {
      position: absolute;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      top: 35px;
      border: 4px solid #fff;
      background: #fff;
      position: absolute;
      top: 0;
      transform: translateY(-50%);
    }
    .t-name {
      position: absolute;
      top: 40px;
      font-size: 16px;
      font-weight: 500;
      color: #000;
      span {
        font-size: 14px;
        font-weight: 400;
        opacity: 0.5;
      }
    }
    .t-desc {
      margin-top: 138px;
      width: 100%;
      box-sizing: border-box;
      padding-left: 28px;
      padding-right: 18px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .d-left {
        flex: 1;
        word-break: break-all;
        margin-right: 20px;
        .l-list {
          font-size: 13px;
          font-weight: 500;
          color: #000000;
          line-height: 22px;
        }
        .l-title {
          margin-top: 8px;
          font-size: 30px;
          font-weight: 500;
          color: #000000;
          line-height: 42px;
        }
      }
      .d-right {
        width: 94px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-left: -6px;
        .r-img {
          margin-left: 6px;
          width: 80px;
        }
        .r-img-more {
          margin-bottom: 6px;
          width: 40px;
        }
      }
      .d-right-three {
        transform: rotate(180deg);
        img {
          transform: rotate(180deg);
        }
      }
    }
    .t-desc-one {
      margin-top: 88px;
    }
    .t-say {
      width: 295px;
      margin-top: 12px;
    }
  }
  img.qr-bot {
    margin-top: 16px;
    width: 335px;
    box-sizing: border-box;
    display: block;
  }
  .qr-btn {
    width: 100%;
    box-sizing: border-box;
    height: 80px;
    // background: #f00;
    position: absolute;
    bottom: 120px;
  }
}
</style>
